var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "currentColor", fillRule: "nonzero" },
            React.createElement("path", { d: "M22.697 12c.204 0 .438.047.672.127v4.45c0 1.613 1.43 3.075 3.008 3.075h3.617l.001 1.887A4.001 4.001 0 0028 25.003l-.001.996-.996.001a4.003 4.003 0 00-.213 8H13c-.55 0-1-.48-1-1.066V13.066c0-.586.45-1.066 1-1.066h9.697zM25 13c1.397 1.406 2.502 2.516 3.313 3.329l.291.291.135.135.364.363c.592.591.89.885.897.882h-3.514c-.75 0-1.485-.764-1.485-1.454L25 13z" }),
            React.createElement("path", { d: "M32.003 23c1.106 0 2.003.897 2.003 2.003l-.001 2.996 2.992.001a2.003 2.003 0 010 4.006l-2.992-.001v2.992a2.003 2.003 0 01-4.005 0l-.001-2.992h-2.996a2.003 2.003 0 010-4.005l2.996-.001.001-2.996c0-1.106.897-2.003 2.003-2.003z" }))));
});
